import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNgxMask } from 'ngx-mask';

import { routes } from './app.routes';
import { initializeUser } from './app-init';

import { SentryErrorHandler } from '../ErrorHandler';

import { provideClientHydration } from '@angular/platform-browser';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { sessionCookieInterceptor } from './http/session-cookie.interceptor';
import { sessionExpiredInterceptor } from './http/session-expired.interceptor';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha-2';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: SentryErrorHandler },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptors([sessionCookieInterceptor, sessionExpiredInterceptor])
    ),
    importProvidersFrom(ReactiveFormsModule, RecaptchaModule),
    provideAppInitializer(initializeUser),
    provideAnimations(),
    provideNgxMask(), provideServiceWorker('ngsw-worker.js', {
            enabled: environment.production || environment.environment === 'staging',
            registrationStrategy: 'registerWhenStable:30000'
          }),
  ],
};
